import { createSlice } from '@reduxjs/toolkit'
import { getGameSetting, roundVerifyHash } from 'redux-store/thunk/gameSettings.thunk'
import { generateServerSeed } from 'redux-store/thunk/user.thunk'
import { generateClientSeed } from 'helpers/common.helpers'

const initialState = {
  systemGameData: null,
  allCurrencies: [],
  gameSettings: [],
  gameSettingLoader: false,
  clientSeed: generateClientSeed(),
  serverSeedHash: '',
  gameMusic: false,
  gameSound: true,
  roundHashDetails: null
}

const setClientSeed = () => {

}

const {
  actions: {
    setAllCurrency,
    setGameSettings,
    setGameSettingLoader,
    setNewClientSeed,
    setServerSeedHash,
    setGameMusic,
    updateGameSetting,
    setGameSound,
    resetGameHashDetails
  },
  reducer
} = createSlice({
  name: 'gameSetting',
  initialState,
  reducers: {
    setAllCurrency: (state, action) => ({
      ...state,
      allCurrencies: action.payload
    }),
    setGameSettings: (state, action) => ({
      ...state,
      gameSettings: action.payload
    }),
    setGameSettingLoader: (state, action) => ({
      ...state,
      setGameSettingLoader: action.payload
    }),
    setNewClientSeed: (state, action) => ({
      ...state,
      clientSeed: action.payload
    }),
    setServerSeedHash: (state, action) => ({
      ...state,
      serverSeedHash: action.payload
    }),
    setGameMusic: (state, action) => ({
      ...state,
      gameMusic: !state.gameMusic
    }),
    setGameSound: (state, action) => ({
      ...state,
      gameSound: !state.gameSound
    }),
    updateGameSetting: (state, action) => {
      return {
        ...state,
        systemGameData: action.payload
      }
    },
    resetGameHashDetails: (state, action) => ({
      ...state,
      roundHashDetails: null
    })
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGameSetting.fulfilled, (state, action) => {
        return {
          ...state,
          systemGameData: action.payload,
          gameSettingLoader: false
        }
      })
      .addCase(generateServerSeed.fulfilled, (state, action) => {
        return {
          ...state,
          serverSeedHash: action.payload?.serverSeedHash ?? ''
        }
      })
      .addCase(generateServerSeed.rejected, (state, action) => {
        return {
          ...state
        }
      })
      .addCase(roundVerifyHash.fulfilled, (state, action) => {
        return {
          ...state,
          roundHashDetails: action.payload
        }
      })
  }
})

export default reducer
export {
  setAllCurrency,
  setGameSettings,
  setGameSettingLoader,
  setNewClientSeed,
  setGameMusic,
  setServerSeedHash,
  updateGameSetting,
  setGameSound,
  setClientSeed,
  resetGameHashDetails
}
